import axios from 'axios'
import { ReceiptDraftInterface, ReceiptInterface } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'

import { DocumentTypes } from '../Interfaces/Draft/DraftInterface'
import { getDocumentV1 } from './document'
import { getRequestConfig } from './index'

export const getNextNumber = async () => {
  const url = '/receipts/number/next'
  const response = await axios.get(url, getRequestConfig())
  return response.data
}

export async function saveReceipt(receipt: ReceiptDraftInterface) {
  const url = `/rest-invoice/api/v1/receipts/${receipt.id}`
  delete receipt.id
  const response = await axios.put(url, receipt, getRequestConfig())
  return response.data
}

export async function getReceipt(id: number): Promise<ReceiptInterface> {
  return getDocumentV1<ReceiptInterface>(DocumentTypes.RECEIPT, id)
}
